import styled from "styled-components";

export const Bigsection = styled.div`
  min-height: 60vh;
`;
